import React from 'react';
import ReactDOM from 'react-dom';
import './style/style.scss';
import App from './components/app/App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
